/*
* Copyright (C) Regione Lombardia
*/
import { HttpHeaders } from '@angular/common/http';

export const REGEX_CF = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
export const REGEX_ISO_DDMMYYYY = '[0-9][0-9]/[0-9][0-9]/[0-9][0-9][0-9][0-9]';
export const REGEX_ISO_YYYYMMDD = '[0-9][0-9][0-9][0-9].[0-9][0-9].[0-9][0-9]';
export const REGEX_DIGIT = /^-?(0|[1-9]\d*)?$/;
export function applyUserTab() {
    function handleFirstTab(e: any) {
        if (e.keyCode === 9) {
            document.body.classList.add('user-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
            window.addEventListener('mousedown', handleMouseDownOnce);
        }
    }
    function handleMouseDownOnce() {
        document.body.classList.remove('user-tabbing');
        window.removeEventListener('mousedown', handleMouseDownOnce);
        window.addEventListener('keydown', handleFirstTab);
    }
    window.addEventListener('keydown', handleFirstTab);
}
export function initBlIcons() {
    return () => new Promise<any>((resolve: any) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/ods/assets/svg/sprite.svg', true);
        xhr.send();
        xhr.onload = function () {
            const blIcons = document.createElement('div');
            blIcons.style.display = 'none';
            blIcons.innerHTML = xhr.responseText;
            document.documentElement.insertBefore(blIcons, document.documentElement.firstChild);
            resolve();
        };
        xhr.onerror = function () { resolve(); };
    });
}
export function headerProjectCache(): HttpHeaders {
    return new HttpHeaders({
        'projectCache': '1',
    });
}
export function specialCharacters(text: string) {
    if (text) {
        /** Questi caratteri sono quelli più ricorrenti e per questo motivo li sostituiamo noi direttamente */
        text = text.replace('`', '\'');
        text = text.replace('’', '\'');
        text = text.replace('“', '\"');
        text = text.replace('”', '\"');
        text = text.replace('–', '-');
        text = text.replace('—', '-');
        return text.replace(new RegExp(/[^\x20-\x7d | \x09 | \x0a | \xE0 | \xE8-\xE9 | \xEc |\xF2 |\xF9]/, 'g'), '');
    }
    return text;
}
export function doDownload(response: any, fileName: string, typeOfFile: string) {
    const newBlob = new Blob([response], { type: `application/${typeOfFile}` });
    /**
     * For other browsers:
     * Create a link pointing to the ObjectURL containing the blob.
     */
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = `${fileName}.${typeOfFile}`;
    /* this is necessary as link.click() does not work on the latest firefox */
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    setTimeout(() => {
        /* For Firefox it is necessary to delay revoking the ObjectURL */
        window.URL.revokeObjectURL(data);
        link.remove();
    }, 100);
}
